import React, { useState, useEffect,memo } from 'react';
import { useLazyQuery, useQuery } from '@apollo/client';
import Select from 'react-select';

const DropdownWithFetch = memo(({ onChange, token,value,query,queryType,clear, filters = {} ,...props}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch data using lazy query from Apollo
  const [getOptionsData, { data, error }] = useLazyQuery(query, {
    fetchPolicy: 'no-cache',
    context: {
      headers: {
        authorization: `Bearer ${token}`,
      },
    },
  });
  // Fetch options when component is mounted
  useEffect(() => {
   
      setLoading(true);
      //getOptionsData();
       // Call the query with the 'type' variable
  getOptionsData({
    variables: {
      type: queryType, // Pass your 'type' here
      ...filters
    },
  });
      
}, [getOptionsData,filters]);
  // Process and set the options once data is fetched
  useEffect(() => {
    // if(dropDownOptions.length > 0){
    //     setOptions(dropDownOptions);
    // }
     if (data) {
        let dynamicData = getDeepestArray(data);
      // const listOptions = dynamicData && dynamicData.map((obj) => ({
      //   label: obj.name ? obj.name : `${obj.first_name} ${obj.last_name}`, // Adjust based on your data structure
      //   code: obj.arcimedes_row_id,
      // }));
       const listOptions = dynamicData
         ? dynamicData
           .filter(obj => obj.name || (obj.first_name && obj.last_name)) // Filter valid objects
           .map(obj => ({
             label: obj.name ? obj.name : `${obj.first_name} ${obj.last_name}`, // Create label
             code: obj.arcimedes_row_id, // Add code
           }))
           .sort((a, b) => a.label.localeCompare(b.label)) // Sort by label alphabetically
         : [];
      setOptions(listOptions);
      setLoading(false);
    }
    if (error) {
      console.error("Error fetching options:", error);
      setLoading(false);
    }
  }, [data, error]);

  useEffect(() => {
    if (clear) {
      onChange(null);
    }
  }, [clear, onChange]);
  
function getDeepestArray(data) {
    // Helper function to recursively search for the deepest array
    function findArray(obj) {
        if (Array.isArray(obj)) {
            return obj; // Return if the current object is an array
        }

        if (typeof obj === 'object' && obj !== null) {
            for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                    const result = findArray(obj[key]);
                    if (result) {
                        return result;
                    }
                }
            }
        }

        return null; // No array found
    }

    return findArray(data);
};
  return (
    // <div style={{marginBottom:"2px",height:"37px"}}>
    <div style={{ marginBottom: "2px" }}>
      {loading ? (
        <div>Loading...</div> // You can customize this loading indicator
      ) : (
        <Select
          options={options}
          onChange={onChange}
          placeholder="Select"
          value={
            options.find((item) => value && item.code === value.code) || null
          }
          getOptionLabel={(e) => e.label} // Ensure labels are rendered correctly
          getOptionValue={(e) => e.code}
          isClearable
          {...props}
  styles={{
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,                  // above sticky header
    }),
    menu: (base) => ({
      ...base,
      marginTop: 0,                  // no gap
    }),
    control: (base) => ({
      ...base,
      minHeight: "32px",
    }),
  }}

        />
      )}
    </div>
  );
});

export default DropdownWithFetch;
